<template>
  <div class="invitee-attended-events grid-stack grid-gap-0">
    <p class="body-medium-bold invitee-attended-events__title">Attended events:</p>

    <div
      v-for="event in events"
      :key="event.id"
      class="invitee-attended-events__row grid grid-gap-12 align-items-center"
    >
      <span class="col-12 col-sm-3">{{ event.name }}</span>
      <span class="col-12 col-sm-2">{{ getEventBrandName(event.brandCode) }}</span>
      <span class="col-12 col-sm-2">{{ event.location }}</span>
      <span class="col-12 col-sm-2">{{ formatDate(event.startDate) }}</span>
      <EventStatusChip
        class="justify-self-start col-12 col-sm-1"
        :is-archived="event.isArchived"
        :status="getEventStatus(event)"
      />
      <router-link
        class="invitee-attended-events__detail-link col-12 col-sm-2 justify-self-start"
        :to="{
          name: 'event-invitee-detail',
          params: {
            eventId: event.id,
            inviteeId: event.eventInviteeId,
          },
          query: {
            ...returnQuery,
            from: 'invitees-list',
            expandedInviteeId: candidateId,
          },
        }"
      >
        DETALJI UZVANIKA
      </router-link>
    </div>
  </div>
</template>

<script setup>
import EventStatusChip from './EventStatusChip.vue'
import { formatDate, getEventBrandName, getEventStatus } from '../helpers'

defineProps({
  candidateId: {
    type: String,
    required: true,
  },

  returnQuery: {
    type: Object,
    default: () => ({}),
  },

  events: {
    type: Array,
    required: true,
  },
})
</script>

<style
  scoped
  lang="scss"
>
.invitee-attended-events {
  padding: 12px 18px;

  &__title {
    margin: 0;
    padding-bottom: 8px;
  }

  &__row {
    padding: 12px 0;
    border-bottom: 1px solid var(--color-border);
    color: var(--color-text-body);

    &:last-child {
      border-bottom: 0;
    }
  }

  &__detail-link {
    color: var(--color-black);
    font-size: 14px;
    line-height: 22px;
    text-decoration: underline;
    white-space: nowrap;
  }
}
</style>
